import { DeleteIcon } from 'components/Icon';

import styles from './OverduePanel.module.scss';

export type OverduePanelProps = {
  onDelete?(): void;
};

const OverduePanel = ({ onDelete }: OverduePanelProps) => (
  <div className={styles.container}>
    <p className={styles.title}>Your event is overdue, please delete it and create new one!</p>
    <button type="button" className={styles.delete} onClick={onDelete}>
      <DeleteIcon />
      <span>Delete the event</span>
    </button>
  </div>
);

export default OverduePanel;
